import "./StorageUsage.scss";
import React from "react";
import { LinearProgress } from "@mui/material";
import { BUTTON_SIZE, BUTTON_THEME, Button } from "App/core/Button";
import { useHistory } from "react-router";
import { PLANS } from "../Plans/config";
import { useAuth } from "../Auth";

export const SpaceUsage = () => {
  const history = useHistory();
  const { user, activeSpacesLimit } = useAuth();
  const isLimited = activeSpacesLimit < Infinity;
  const { activeSpacesUsed, subscriptionTier: tier } = user;
  const plan = PLANS.find((p) => p.tier === tier);

  return (
    <div className="highnote-storage-usage">
      {isLimited && (
        <div className="storage-bar">
          <LinearProgress
            variant="determinate"
            value={Math.min((activeSpacesUsed / activeSpacesLimit) * 100, 100)}
          />
        </div>
      )}

      <p className="hint">
        {`You are using ${activeSpacesUsed} out of ${
          isLimited ? activeSpacesLimit : "unlimited"
        } Shared Spaces allowed on your `}
        <Button
          theme={BUTTON_THEME.LINK}
          size={BUTTON_SIZE.AUTO}
          type="button"
          onClick={() => history.push(`/settings/plans`)}
        >
          {plan.name} Plan
        </Button>
        .
      </p>
    </div>
  );
};
